import { render } from "./GoogleOAuthHandling.vue?vue&type=template&id=2ac0f3b3"
import script from "./GoogleOAuthHandling.vue?vue&type=script&lang=js"
export * from "./GoogleOAuthHandling.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__